import type { LandingStrings } from './en';

// Перевод на французский 2026-10-24 (по смыслу ru.ts, термины — как в игре и на странице App Store).
export const fr: LandingStrings = {
  header: {
    brandSubtitle: 'Boutique magique',
    contact: 'Contact',
    about: 'À propos',
    language: 'Langue',
  },
  footer: {
    terms: 'Conditions d’utilisation',
    privacy: 'Politique de confidentialité',
    copyright: '{year} {holder}. Tous droits réservés.',
  },
  home: {
    heroTitle: 'Un jeu cosy en 3D, entre potions et boutique magique.',
    heroDescription:
      'Cherche des ingrédients dans le bric-à-brac magique, prépare des potions au chaudron et vends-les dans ta propre boutique.',
    features: [
      {
        title: 'Ton propre flacon',
        desc: 'Forme, bouchon et couleur de la potion — les plus jolis flacons se vendent plus cher.',
      },
      {
        title: 'Un savoir-faire qui a du sens',
        desc: 'Chaque potion a sa propre recette, et beaucoup ont un vrai effet dans le jeu.',
      },
      {
        title: 'Une histoire à suivre',
        desc: 'Grand-mère est partie en vacances et t’a confié sa boutique, mais une grenouille nommée Moren réclame son dû.',
      },
      {
        title: 'Une boutique vraiment à toi',
        desc: 'On n’y vend que ce que tu as préparé de tes mains.',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: 'Bientôt disponible',
    tags: { search: 'Ingrédients cachés', craft: 'Potions au chaudron 3D', shop: 'Boutique cosy' },
  },
  about: {
    title: 'À propos de Qevryno',
    intro: [
      'Bienvenue dans Qevryno, un jeu cosy de préparation de potions où la magie est faite main.',
      'Grand-mère est partie en vacances et t’a demandé de veiller sur sa mystérieuse vieille maison : des recettes oubliées, des ingrédients magiques et un chaudron qui se rappelle encore comment bouillir. En bas, il y a une petite boutique, et tout le village se demande déjà qui s’en occupe désormais.',
      'Prépare des potions, prends soin de ton familier tout doux, vends tes créations à des clients charmants et gagne des pièces pour décorer ta maison magique — à ton rythme, sans chrono.',
    ],
    whatTitle: 'Quel genre de jeu est-ce ?',
    what: [
      'Qevryno est un jeu de puzzle relaxant en 3D qui mêle recherche d’objets, craft alchimique et petit simulateur de boutique. Si tu aimes les jeux cosy, les jeux de puzzle casual, les jeux d’objets cachés, les jeux de potions, l’alchimie et l’idée de tenir ta propre boutique magique, ce jeu est fait pour toi.',
      'C’est un jeu solo qui fonctionne hors ligne ; Internet ne sert qu’aux achats et aux vidéos récompensées facultatives. Pas de bannières ni de pop-ups publicitaires : une courte vidéo Google AdMob contre un bonus ne démarre que si tu la lances toi-même. Achats facultatifs : des gemmes et des lots d’ingrédients au contenu visible. Bientôt disponible sur iOS et Android, en français, anglais, russe, espagnol, allemand, néerlandais, italien, portugais (Brésil), polonais, japonais, coréen, chinois traditionnel et turc.',
    ],
    doTitle: 'Ce que tu vas faire',
    doList: [
      'Chercher des ingrédients cachés dans des clairières forestières magiques en 3D — chacune est comme un petit diorama.',
      'Préparer des recettes magiques au chaudron : un stabilisateur, un ingrédient principal, des herbes du temps et une touche de couleur.',
      'Créer tes propres flacons — forme, bouchon, couleur de la potion ; les plus jolis se vendent plus cher.',
      'Tenir ta propre boutique : clients, réputation, foires et quêtes.',
      'Suivre l’histoire : grand-mère est partie en vacances et t’a confié sa boutique, mais une grenouille nommée Moren ne cesse de réclamer son dû.',
      'Broyer tes trouvailles au mortier, les mélanger dans le bol et ajouter des paillettes — chaque mélange a sa texture et sa couleur.',
      'Nourrir ton familier et décorer ta boutique.',
    ],
    faqTitle: 'Questions fréquentes',
    faq: [
      { q: 'Qevryno est-il gratuit ?', a: 'Oui. Le jeu est gratuit, et on peut y jouer sans rien payer. Achats facultatifs : des gemmes et des lots d’ingrédients.' },
      { q: 'Le jeu fonctionne-t-il hors ligne ?', a: 'Oui. Le jeu en lui-même n’a pas besoin de connexion — prépare des potions en avion ou sous un plaid. Internet ne sert qu’aux achats et aux vidéos récompensées facultatives.' },
      { q: 'Y a-t-il des publicités ?', a: 'Seulement des publicités facultatives. Pas de bannières ni de pop-ups entre les écrans. À quelques endroits, tu peux choisir de regarder une courte vidéo pour obtenir un bonus, par exemple du mana. Rien dans le jeu n’oblige à les regarder. Les vidéos sont fournies par Google AdMob ; pour en savoir plus, consulte la Politique de confidentialité.' },
      { q: 'Sur quelles plateformes ?', a: 'iOS et Android, en français, anglais, russe, espagnol, allemand, néerlandais, italien, portugais (Brésil), polonais, japonais, coréen, chinois traditionnel et turc.' },
      { q: 'Est-ce effrayant ou stressant ?', a: 'Pas du tout. C’est un jeu calme et cosy : une musique douce, aucune punition pour les erreurs et un chat coiffé d’un chapeau.' },
    ],
  },
  contact: {
    title: 'Nous contacter',
    subtitle: 'Une question sur Qevryno, un bug, un achat ou une pub ? Écris-nous par e-mail.',
    write: 'Écrire un e-mail',
    mailSubject: 'Qevryno : assistance',
    tip: 'Dis-nous quel appareil tu utilises et ce qui s’est passé : ce sera plus facile de t’aider.',
    info: {
      title: 'Contacts',
      email: 'E-mail',
      security: 'Sécurité',
      legalName: 'Développeuse',
      address: 'Adresse',
    },
    refunds: {
      title: 'Remboursements et achats',
      description: 'Tous les achats passent par l’Apple App Store ou Google Play. Pour demander un remboursement, adresse-toi au magasin d’applications :',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/fr-fr/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=fr',
      link: 'Demander un remboursement',
      note: 'Nous n’encaissons pas les paiements nous-mêmes et ne pouvons pas effectuer de remboursement. Si un achat n’est pas arrivé dans le jeu, ouvre « Réglages → Restaurer les achats » ou écris-nous.',
    },
  },
  legal: {
    dataController: 'Responsable du traitement',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: 'Ce document n’existe qu’en anglais, en russe et en espagnol. La version anglaise figure ci-dessous.',
  },
};
